// Update IntegrationsCategoriesContainer.js
import React, { useState, useRef } from 'react';
import { Box } from '@mui/material';
import IntegrationsCategoriesMenu from './IntegrationsCategoriesMenu';
import CRMContainer from './CRMContainer';
import HRContainer from './HRContainer';
import EmailContainer from './EmailContainer';
import SAMLContainer from './SAMLContainer';
import CalendarContainer from './CalendarContainer';

const IntegrationsCategoriesContainer = ({ searchTerm = '' }) => {
    const [activeCategory, setActiveCategory] = useState('CRM');
    const containerRef = useRef(null);
    const sectionRefs = {
        'CRM': useRef(null),
        'HR': useRef(null),
        'Email': useRef(null),
        'SAML': useRef(null),
        'Calendar Booking': useRef(null)
    };

    const handleCategoryChange = (categoryName) => {
        setActiveCategory(categoryName);
        
        if (sectionRefs[categoryName] && sectionRefs[categoryName].current) {
            const sectionElement = sectionRefs[categoryName].current;
            const containerElement = containerRef.current;

            if (containerElement && sectionElement) {
                const sectionTop = sectionElement.offsetTop;
                containerElement.scrollTop = sectionTop;
            }
        }
    };

    return (
        <Box
            sx={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                height: '100%',
                display: 'flex',
                pt: 3,
                px: 1,
                flexDirection: 'column',
                overflow: 'hidden'
            }}
        >
            <Box sx={{ flexShrink: 0 }}>
                <IntegrationsCategoriesMenu
                    activeCategory={activeCategory}
                    onCategoryChange={handleCategoryChange}
                />
            </Box>
            
            <Box
                ref={containerRef}
                sx={{
                    flex: 1,
                    overflowY: 'auto',
                    px: 3,
                    pb: 3,
                    position: 'relative',
                    '&::-webkit-scrollbar': {
                        width: '8px'
                    },
                    '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                        borderRadius: '4px'
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: '#888',
                        borderRadius: '4px',
                        '&:hover': {
                            background: '#555'
                        }
                    }
                }}
            >
                <Box 
                    ref={sectionRefs['CRM']}
                    id="CRM" 
                    sx={{ position: 'relative', mb: 6 }}
                >
                    <CRMContainer searchTerm={searchTerm} />
                </Box>
                <Box 
                    ref={sectionRefs['HR']}
                    id="HR" 
                    sx={{ position: 'relative', mb: 6 }}
                >
                    <HRContainer searchTerm={searchTerm} />
                </Box>
                <Box 
                    ref={sectionRefs['Email']}
                    id="Email" 
                    sx={{ position: 'relative', mb: 6 }}
                >
                    <EmailContainer searchTerm={searchTerm} />
                </Box>
                <Box 
                    ref={sectionRefs['SAML']}
                    id="SAML" 
                    sx={{ position: 'relative', mb: 6 }}
                >
                    <SAMLContainer searchTerm={searchTerm} />
                </Box>
                <Box 
                    ref={sectionRefs['Calendar Booking']}
                    id="Calendar Booking" 
                    sx={{ position: 'relative', mb: 6 }}
                >
                    <CalendarContainer searchTerm={searchTerm} />
                </Box>
            </Box>
        </Box>
    );
};

export default IntegrationsCategoriesContainer;